import { Colors } from "colors";
import { StyleSheet } from "react-native";
import { fp } from "./normalise";

export const CommonStyles = StyleSheet.create({
    headingText20: {
        fontWeight: "550",
        fontSize: 20,
        lineHeight: 28,
        paddingBottom: 8,
    },
    headingText: {
        fontWeight: "550",
        fontSize: 15,
        lineHeight: 28,
    },
    subHeadingGreyText: {
        fontWeight: "350",
        fontSize: 13,
        lineHeight: 20,
        color: "rgba(0, 0, 0, 0.5)",
    },
    subHeadingText15: {
        fontWeight: "350",
        fontSize: fp(16),
        lineHeight: fp(24),
        color: "rgba(33, 36, 39, 1)",
    },
    subHeadingGreyText15: {
        fontWeight: "350",
        fontSize: 15,
        lineHeight: 24,
        color: "rgba(0, 0, 0, 0.5)",
    },
    iconSize: {
        width: 16,
        height: 16,
        marginRight: 8,
    },
    smallBodyText: {
        fontSize: 14,
        fontWeight: "350",
        lineHeight: 20,
        color: Colors.black,
    },
    rowDirection: {
        flexDirection: "row",
    },
    rowDirectionCenter: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
    },
    hitSlop: {
        top: 20,
        bottom: 20,
        left: 20,
        right: 20,
    },
});
